import { DtGeolocation } from '@ow/ditto-core'

const { validation, transformer } = DtGeolocation

export { default as Render } from './render'
export { validation, transformer }
